import { render, staticRenderFns } from "./CriticalMineral.vue?vue&type=template&id=1cd826ea&scoped=true"
import script from "./CriticalMineral.vue?vue&type=script&lang=js"
export * from "./CriticalMineral.vue?vue&type=script&lang=js"
import style0 from "./CriticalMineral.vue?vue&type=style&index=0&id=1cd826ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cd826ea",
  null
  
)

export default component.exports